/**
 * @param {*} value
 * @returns {value is Array}
 */
export function isArray(value) {
  return Array.isArray(value);
}
